/**
 * 新建/编辑 部门
 */
import React from 'react';
import { Modal, Form, Input, Select } from 'antd';
import PropTypes from 'prop-types';
import model from '@/reducers/permissions/structure/model';
import { connect } from 'react-redux';
import http from '@/assets/api/http';
import { message } from 'antd';
import { getLocalStorage } from '@/assets/js/storage';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const { Option } = Select;
const { TextArea } = Input;

class DeptModal extends React.Component {
    formRef = React.createRef();
    state = {
        confirmLoading: false,
        parentDeptDisable: false, // 顶级部门是否可编辑
        isAdmin: 0,
    }

    componentDidMount() {
        const { children } = this.props.param || {};
        const editDeptId = this.props.param?.id || null;
        this.props.getDeptPullDown({ isNeedSanji: 1, isNeePermissionFilter: 1 });
        this.props.getEmpPullDown({ editDeptId });
        if (Array.isArray(children) && children.length > 0) {
            this.setState({ parentDeptDisable: true });
        }
        const userInfo = getLocalStorage('auth') ? JSON.parse(getLocalStorage('auth')).userInfo : null;
        this.setState({ isAdmin: userInfo.isAdmin });
    }

    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            this.setState({ confirmLoading: true });
            const { parentId, deptName, principalsId, remark } = fieldsValue;
            const { type, param } = this.props;
            if (type == 'new') {
                http('/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.addDeptInfo', { parentId, deptName, principalsId, remark }, 'POST').then(() => {
                    message.success('创建成功');
                    this.setState({ confirmLoading: false });
                    this.props.closeModal(true);
                }).catch((e) => {
                    message.error(e.message);
                    this.setState({ confirmLoading: false });
                });
            } else {
                http('/?cmd=com.xqxc.api.pig.mis.biz.account.DeptMisService.updateDeptInfo', { id: param.id, parentId, deptName, principalsId, remark }, 'POST').then(() => {
                    message.success('编辑成功');
                    this.setState({ confirmLoading: false });
                    this.props.closeModal(true);
                }).catch((e) => {
                    message.error(e.message);
                    this.setState({ confirmLoading: false });
                });
            }
        });
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading, parentDeptDisable, isAdmin } = this.state;
        const { param, type, deptPullDown, empPullDown } = this.props;
        const { parentId, deptName, principalsId, principalsTel, remark } = param || {};

        return (
            <Modal
                width={600}
                centered
                title={this.props.title}
                open={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <Form
                    style={{ margin: '0 20px' }}
                    {...formItemLayout}
                    ref={this.formRef}
                    initialValues={{
                        parentId,
                        deptName,
                        principalsId,
                        principalsTel,
                        remark
                    }}
                    scrollToFirstError
                >
                    <Form.Item
                        label="上级部门"
                        name="parentId"
                        rules={[{ required: true }]}
                    >
                        <Select allowClear placeholder='请选择上级部门' disabled={parentDeptDisable}>
                            {isAdmin == 1 || (type == 'edit' && parentDeptDisable) ? <Option key={0} value={0}>顶级部门</Option> : 0}
                            {
                                deptPullDown.map((item) => {
                                    return <Option key={item.id} value={item.id}>{item.deptName}</Option>;
                                })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="部门名称"
                        name="deptName"
                        rules={[
                            { required: true },
                            { max: 28, message: '最多可输入28个字' },
                        ]}>
                        <Input placeholder='请输入部门名称' />
                    </Form.Item>
                    <Form.Item
                        label="负责人"
                        name="principalsId"
                    >
                        <Select allowClear
                            placeholder='请选择选择负责人'
                            showSearch={true}
                            filterOption={(input, option) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            onChange={(id, item) => {
                                this.formRef.current.setFieldsValue({ principalsTel: item['data-tel'] });
                            }}>
                            {
                                empPullDown.map((item) => {
                                    return <Option key={item.id} value={item.id} data-tel={item.tel}>{item.emplName}</Option>;
                                })
                            }
                        </Select>
                    </Form.Item>
                    <Form.Item
                        label="手机号码"
                        name="principalsTel"
                    >
                        <Input placeholder='选中负责人后，将根据负责人录入资料自动填入' disabled />
                    </Form.Item>
                    <Form.Item
                        label="备注"
                        name="remark"
                        rules={[
                            { max: 200, message: '最多可输入200个字' },
                        ]}
                    >
                        <TextArea placeholder='请输入备注' rows={5} maxLength={200} showCount={true} />
                    </Form.Item>
                </Form>
            </Modal>
        );

    }
}

DeptModal.propTypes = {
    title: PropTypes.string.isRequired, // 弹框标题
    closeModal: PropTypes.func.isRequired, // 关闭弹框
    param: PropTypes.object, // 入参对象
    type: PropTypes.string, // 编辑类型
    getDeptPullDown: PropTypes.func,
    deptPullDown: PropTypes.array,
    getEmpPullDown: PropTypes.func,
    empPullDown: PropTypes.array
};

const mapStateToProps = (state) => ({
    deptPullDown: state.structure.getDeptPullDown,
    empPullDown: state.structure.getEmpPullDown
});
export default connect(mapStateToProps, { ...model.actions })(DeptModal);
